import React from 'react';
import { Link } from 'react-router-dom';
import { FaMicrophone, FaEnvelope } from 'react-icons/fa';
import '../styles/Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  // Email protection function
  const revealEmail = (e) => {
    e.preventDefault();
    const name = 'coleman';
    const domain = 'dubbah';
    const tld = 'co';
    window.location.href = `mailto:${name}@${domain}.${tld}`;
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-logo">
            <Link to="/">
              <FaMicrophone className="logo-icon" />
              <span className="logo-text">DUBBAH</span>
            </Link>
            <p>Professional audio dubbing services in 28+ languages</p>
          </div>

          <div className="footer-links">
            <div className="footer-column">
              <h3>Navigate</h3>
              <ul>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/services">Services</Link></li>
              </ul>
            </div>

            <div className="footer-column">
              <h3>Services</h3>
              <ul>
                <li><Link to="/services">Ad Localization</Link></li>
                <li><Link to="/services">Dynamic Content</Link></li>
                <li><Link to="/services">Global Dubbing</Link></li>
              </ul>
            </div>

            <div className="footer-column">
              <h3>Contact</h3>
              <ul>
                <li>
                  <a href="#" onClick={revealEmail}>
                    <FaEnvelope className="icon-margin-right" /> Email Us
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} DUBBAH. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
